import styled from 'styled-components';

import colors from '@theme/colors';

export const FieldLabel = styled.label`
  font-family: GTAmerica;
  display: inline-block;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  letter-spacing: 2.75px;
  color: ${({ dark }) => (dark ? colors['very-light-brown'] : colors['ash'])};

  &.ltr {
    float: left;
  }
  &.rtl {
    float: right;
  }
`;

export default FieldLabel;
